exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-4ef62fbb] .el-form-item {\n  margin-bottom: 4px;\n}\n", ""]);

// exports
